import AxiosBaseInstance from 'services/HTTPService/AxiosBaseInstance';
import { CreateChildEnrollmentDTO, EnrollmentId } from 'types/enrollment/enrollment';
import { ENROLLMENT } from 'services/HTTPService/enrollment/endpoints';

class EnrollmentHTTPService {
    private axios = new AxiosBaseInstance();

    addChildEnrollment = ({
        enrollmentId,
        createChildEnrollmentDTO,
    }: {
        enrollmentId: EnrollmentId;
        createChildEnrollmentDTO: CreateChildEnrollmentDTO;
    }) => this.axios.post(ENROLLMENT(enrollmentId), createChildEnrollmentDTO);
}

export default new EnrollmentHTTPService();
